import React, { ComponentType } from 'react';
import { useBoolean } from 'react-hanger';
import { globalStore, Provider } from 'stores';
import { utils } from './index';
// import Loadable from 'react-loadable'

// type T =  string | number
// const add = (a: string | number, b: T): T => {
//   return a + b;
// }

type Options = {
  onClose?: Function;
  key?: string;
  [p: string]: any;
};

type Props = {
  onClose?: Function;
  isShow?: boolean;
  id?: string;
  isClose?: boolean;
  show?: Function;
  close?: Function;
};

const render = (
  options: Partial<Options> = {},
  Component: ComponentType<Props> & Props,
) => {
  const { key = utils.getRandomString(), ...restOptions } = options;
  let { modal } = globalStore;

  let close = () => {
    if (options && options.onClose) {
      options.onClose();
    }
    modal.remove(key);
  };
  modal.add(key, () => {
    return <Component id={key} {...restOptions} onClose={close} />;
  });
  return close;

  // Component.close = close
  // ReactDOM.render(<Provider value={ globalStore }><WithTheme><Component
  //   { ...options }
  //   onClose={ close }
  // /></WithTheme></Provider>, div);
  // return close
};

const withPopup = (Component: ComponentType<Props> & Props) => {
  let close: Function | null = null;
  Component.isClose = true;

  Component.show = (options: Options) => {
    let close = render(options, Component);
    Component.close = close;
    return close;
  };
  Component.close = () => {
    close && close();
  };

  return Component;
};

const withTheme = () => {};

//
// const loadable = (loader, dataLoader) => {
//     let loading = (props) => {
//         if (props.error) {
//             return <div className={ 'text-center' }>
//                 <span style={ { marginRight: '3em' } }>load error</span>
//                 <button onClick={ props.retry } className={ 'btn btn-second' }>重试</button>
//             </div>
//         }
//         return <div style={ { padding: '1rem' } }><LoadingBlock /></div>
//     }
//     if (dataLoader) {
//         return Loadable.Map({
//             loader: {
//                 Com: loader,
//                 data: dataLoader
//             },
//             render(loaded, props) {
//                 let Com = loaded.Com.default;
//                 return <Com { ...props } data={ loaded.data } />
//             },
//             loading
//         })
//     }
//
// }
const withDefaultProps = <P extends object, DP extends Partial<P> = Partial<P>>(
  defaultProps: DP,
  Cmp: ComponentType<P>,
) => {
  // 提取出必须的属性
  type RequiredProps = Omit<P, keyof DP>;
  // 重新创建我们的属性定义，通过一个相交类型，将所有的原始属性标记成可选的，必选的属性标记成可选的
  type Props = Partial<DP> & Required<RequiredProps>;

  Cmp.defaultProps = defaultProps;

  // 返回重新的定义的属性类型组件，通过将原始组件的类型检查关闭，然后再设置正确的属性类型
  return Cmp as ComponentType<any> as ComponentType<Props>;
};

const useShow = (defaultVal = false) => {
  const isShow = useBoolean(defaultVal);
  const show = () => {
    isShow.setTrue();
  };
  const hide = () => {
    isShow.setFalse();
  };
  const toggle = () => {
    isShow.toggle();
  };

  return {
    isShow: isShow.value,
    show,
    hide,
    toggle,
  };
};

export default {
  render,
  withPopup,
  withDefaultProps,
  useShow,
};
